module.exports = __webpack_public_path__ + "media/post-listing-block-3-overlay-wide.5cbe0233.webp";